import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';
import '../CSS/Blog.css';
import '../CSS/App.css';

const formatDate = (d) => {
  const [y, m, day] = d.split('-').map(Number);
  return new Date(y, m - 1, day).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
};

const CodeBlock = ({ className, children }) => {
  const language = className?.replace('language-', '') || 'text';
  return (
    <SyntaxHighlighter
      style={vscDarkPlus}
      language={language}
      PreTag="div"
      customStyle={{ borderRadius: '6px', fontSize: '0.9rem', margin: '24px auto', maxWidth: '640px' }}
    >
      {String(children).replace(/\n$/, '')}
    </SyntaxHighlighter>
  );
};

const BlogPost = () => {
  const { slug } = useParams();
  const [meta, setMeta] = useState(null);
  const [content, setContent] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!/^[a-z0-9-]+$/.test(slug)) {
      setError(true);
      return;
    }
    fetch(`/blog-posts/${slug}.md`)
      .then(r => {
        if (!r.ok) throw new Error('not found');
        return r.text();
      })
      .then(text => {
        const fm = {};
        let body = text;
        const m = text.match(/^---\n([\s\S]*?)\n---\n?([\s\S]*)$/);
        if (m) {
          m[1].split('\n').forEach(line => {
            const [k, ...v] = line.split(':');
            if (k.trim()) fm[k.trim()] = v.join(':').trim();
          });
          body = m[2];
        }
        setMeta(fm);
        setContent(body);
      })
      .catch(() => setError(true));
  }, [slug]);

  if (error) {
    return (
      <div className="blog-container">
        <Link to="/blog" className="blog-back-link">← Back to Blog</Link>
        <p>Post not found.</p>
      </div>
    );
  }

  if (!content) {
    return (
      <div className="blog-container">
        <Link to="/blog" className="blog-back-link">← Back to Blog</Link>
        <p>Loading…</p>
      </div>
    );
  }

  return (
    <div className="blog-container">
      <Link to="/blog" className="blog-back-link">← Back to Blog</Link>
      {meta?.title && <p className="blog-post-title">{meta.title}</p>}
      {meta?.tags && <p className="blog-meta">{meta.tags}</p>}
      {meta?.date && <p className="blog-date">{formatDate(meta.date)}</p>}
      <div className="blog-body">
        <ReactMarkdown
          components={{ code: CodeBlock }}
        >
          {content}
        </ReactMarkdown>
      </div>
    </div>
  );
};

export default BlogPost;
